import { createSelector } from '@ngrx/store';

import { isLoadingState, selectErrorState, selectResultState } from '../../@core/fetch-state.utils';
import { selectAppState } from '../app.selectors';
import { AppState } from '../app.state.interface';

export const selectClients = createSelector(selectAppState, (state: AppState) =>
  selectResultState(state.clients),
);

export const selectClientsLoading = createSelector(selectAppState, (state) =>
  isLoadingState(state.clients),
);

export const selectClientsError = createSelector(selectAppState, (state) =>
  selectErrorState(state.clients),
);

export const selectClientsTotalCount = createSelector(
  selectAppState,
  (state) => state.clientsTotalCount,
);

export const selectClient = createSelector(selectAppState, (state) =>
  selectResultState(state.addedClient),
);

export const selectClientLoading = createSelector(selectAppState, (state) =>
  isLoadingState(state.addedClient),
);

export const selectClientError = createSelector(selectAppState, (state) =>
  selectErrorState(state.addedClient),
);

export const selectLoadedClient = createSelector(selectAppState, (state) =>
  selectResultState(state.loadedClient),
);

export const selectLoadedClientLoading = createSelector(selectAppState, (state) =>
  isLoadingState(state.loadedClient),
);

export const selectLoadedClientError = createSelector(selectAppState, (state) =>
  selectErrorState(state.loadedClient),
);

export const selectUpdatedClient = createSelector(selectAppState, (state) =>
  selectResultState(state.updatedClient),
);

export const selectUpdatedClientLoading = createSelector(selectAppState, (state) =>
  isLoadingState(state.updatedClient),
);

export const selectUpdatedClientError = createSelector(selectAppState, (state) =>
  selectErrorState(state.updatedClient),
);

export const selectDuplicatedClient = createSelector(selectAppState, (state) =>
  selectResultState(state.duplicatedClient),
);

export const selectDuplicatedClientError = createSelector(selectAppState, (state) =>
  selectErrorState(state.duplicatedClient),
);

export const selectCountries = createSelector(selectAppState, (state) =>
  selectResultState(state.countries),
);

export const selectCountriesLoading = createSelector(selectAppState, (state) =>
  isLoadingState(state.countries),
);

export const selectCountriesError = createSelector(selectAppState, (state) =>
  selectErrorState(state.countries),
);

export const selectStatesForAddress1 = createSelector(selectAppState, (state) =>
  selectResultState(state.statesForAddress1),
);

export const selectStatesForAddress1Loading = createSelector(selectAppState, (state) =>
  isLoadingState(state.statesForAddress1),
);

export const selectStatesForAddress1Error = createSelector(selectAppState, (state) =>
  selectErrorState(state.statesForAddress1),
);

export const selectStatesForAddress2 = createSelector(selectAppState, (state) =>
  selectResultState(state.statesForAddress2),
);

export const selectStatesForAddress2Loading = createSelector(selectAppState, (state) =>
  isLoadingState(state.statesForAddress2),
);

export const selectStatesForAddress2Error = createSelector(selectAppState, (state) =>
  selectErrorState(state.statesForAddress2),
);
